// 

$(window).load(function() {
	var $leadLeft = $('.container').css('margin-left');
	$('.leaders__head').css({
		'left': $leadLeft
	})
});